import React from "react";

const TruncatedText = ({
                           text,
                           maxLength = 20,
                           className = "",
                           as: Component = "span",
                       }) => {
    if (!text) {
        return <Component className={className}>-</Component>;
    }

    const str = String(text);
    const needsTruncate = str.length > maxLength;
    const display = needsTruncate ? str.slice(0, maxLength) + "…" : str;

    return (
        <Component
            className={className}
            title={str}
        >
            {display}
        </Component>
    );
};

export default TruncatedText;